<template>
  <div class="inv-tabs">
    <div class="inv-tablist" role="tablist" aria-label="Tabs">
      <button
        v-for="tab of orderedTabs"
        :key="`tab-${tab}`"
        @click="selectTab(tab)"
        :id="`tab-${tab}`"
        :aria-selected="tab === currentTab"
        :aria-controls="`panel-${tab}`"
        v-html="tabs[tab]"
        :class="{ active: tab === currentTab }"
        class="inv-tab"
        role="tab"
      ></button>
    </div>
    <div class="inv-tabpanels">
      <template v-for="tab of orderedTabs">
        <div
          v-if="tab === currentTab"
          :key="`tabpanel-${tab}`"
          :id="`panel-${tab}`"
          :aria-labelledby="`tab-${tab}`"
          class="inv-tabpanel"
          role="tabpanel"
          tabindex="0"
        >
          <slot :name="`tabpanel-${tab}`">
            <p>{{ tabs[tab] }} content</p>
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvTabs",
  props: {
    startTab: {
      type: String,
    },
    tabs: {
      type: Object,
      default: () => ({
        tab1: "Tab 1",
        tab2: "Tab 2",
        tab3: "Tab 3",
      }),
    },
    tabOrder: {
      type: Array,
    },
  },
  data() {
    return {
      currentTab: "",
    };
  },
  computed: {
    orderedTabs() {
      return this.tabOrder || Object.keys(this.tabs);
    },
  },
  watch: {
    currentTab(newTab) {
      this.$emit("tab-changed", {
        id: newTab,
        label: this.tabs[newTab],
      });
    },
  },
  mounted() {
    let start = this.startTab || this.$store.state.currentDetailedTab;
    this.selectTab(start);
  },
  methods: {
    selectTab(tabId) {
      this.$store.setDetailedTab(tabId);
      if (tabId === this.currentTab) return;
      this.currentTab = tabId;
    },
  },
};
</script>

<style lang="scss" scoped>
.inv-tabs,
.inv-tabs * {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.inv-tabs {
  background: $blue-dark-bg;
  @include breakpoint(xs) {
    overflow: hidden;
    max-width: calc(100vw - 55px);
  }
}

.inv-tab {
  border: 2px solid $blue-light;
  padding: 10px 15px;
  margin-right: 5px;
  font-size: 16px;
  background: $blue-dark;
  border-radius: 5px 5px 0px 0px;
  @include breakpoint(xs) {
    font-size: rem(12px);
    padding: 7px 10px;
  }
  &.active {
    border: 2px solid $mauve;
    color: $mauve;
    font-weight: $font-weight-bold;
    background: $white;
  }
}

.inv-tablist {
  border-bottom: 1px solid white;
}

.inv-tabpanel {
  position: relative;
  // padding-top: 15px;
  padding: 15px;
  // padding-bottom: 0;
  // border: 1px solid #98A4AE;
  border-radius: 2px;
}
</style>
